import {authApi} from './http-common';
import { SERVER } from '../common/const/networkUrls'

export async function validateTokenApi(token) {
         const response =  await authApi.get(`${SERVER.SERVICES.validateToken}?token=${token}`);  
         const body = await response;        
         return body.data;
}

export async function tokenApi(code) {
         const response =  await authApi.get(`${SERVER.SERVICES.token}?AuthCode=${code}`);  
         const body = await response;
         return body.data;
}

export async function userClaimsApi(token) {
         const response =  await authApi.get(`${SERVER.SERVICES.userClaims}`,
            {
                headers: {
                "Authorization": `Bearer ${token}`
                }
            }
          );  
         const body = await response;
         return body.data;
}

export async function refreshTokenApi(token, refreshToken) {
         const response =  await authApi.get(`${SERVER.SERVICES.refreshToken}?refreshToken=${refreshToken}`,
            {
                headers: {
                "Authorization": `Bearer ${token}`
                }
            }
          );  
         const body = await response;
         return body.data;
}